const clearButton = document.querySelector('.search-form__clear');
if (clearButton) {
    clearButton.addEventListener('click', () => {
        const inputElement = clearButton.parentElement.querySelector('input');
        if (inputElement) {
            inputElement.value = '';
        }
    });
}
